import React, { useState, useEffect, useContext } from "react";
import qs from "query-string";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import { toast } from "react-toastify";
import { Formik, Form, Field } from "formik";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import usePlans from "../../hooks/usePlans";
import { i18n } from "../../translate/i18n";
import { openApi } from "../../services/api";
import toastError from "../../errors/toastError";
import defaultLoginLogo from "../../assets/login-logo-default.png";
import Turnstile from "../../components/Security/Turnstile";

const useStyles = makeStyles((theme) => ({
  root: {
  position: "relative",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  overflowX: "hidden",
  minHeight: "100vh",

  background:
    "radial-gradient(circle at top left, rgba(37,99,235,0.35) 0%, rgba(2,6,23,1) 35%), linear-gradient(180deg, #020617 0%, #081028 100%)",
},
  rootWithBackground: {
    backgroundColor: "#d1d5db",
  },
  backgroundOverlay: {
  position: "absolute",
  inset: 0,
  zIndex: 0,

  background:
    "linear-gradient(180deg, rgba(2,6,23,0.4) 0%, rgba(2,6,23,0.82) 100%)",
},
  backgroundMedia: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 0,
  },
  backgroundImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center center",
    userSelect: "none",
    pointerEvents: "none",
  },
  paper: {
  position: "relative",
  zIndex: 2,

  width: "100%",
  maxWidth: "324px",

  display: "flex",
  flexDirection: "column",
  alignItems: "center",

  background: "rgba(5, 15, 45, 0.78)",

  backdropFilter: "blur(18px)",

  border: "1px solid rgba(59,130,246,0.35)",

  borderRadius: "28px",

  boxShadow:
    "0 0 0 1px rgba(59,130,246,0.08), 0 25px 80px rgba(0,0,0,0.55), 0 0 60px rgba(37,99,235,0.18)",

  padding: "12px 22px 8px",

  margin: "16px",

  overflow: "hidden",

  "&:before": {
    content: '""',
    position: "absolute",
    inset: 0,
    borderRadius: "28px",
    padding: 1,
    background:
      "linear-gradient(180deg, rgba(96,165,250,0.45), rgba(59,130,246,0.08))",
    WebkitMask:
      "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    WebkitMaskComposite: "xor",
    pointerEvents: "none",
  },

  [theme.breakpoints.down("sm")]: {
    maxWidth: "310px",
  },
},
  logoImg: {
  display: "block",
  margin: "0 auto 6px",
  maxWidth: "90px",
  height: "auto",
  filter: "drop-shadow(0 0 24px rgba(59,130,246,0.35))",
},

signupTitle: {
    color: "#ffffff",
  fontSize: 24,
  fontWeight: 800,
  textAlign: "center",
  marginBottom: 6,
},subtitle: {
  textAlign: "center",
  color: "rgba(255,255,255,0.58)",
  marginBottom: 10,
  fontSize: 13,
},
  form: {
    width: "100%",
    marginTop: theme.spacing(2),
  },
  submit: {
  margin: "14px 0 10px",

  background:
    "linear-gradient(90deg, #1D4ED8 0%, #4F46E5 100%)",

  color: "#fff",

  borderRadius: "14px",

  padding: "10px",

  fontWeight: 700,

  fontSize: "0.92rem",

  width: "100%",

  textTransform: "none",

  boxShadow:
    "0 12px 24px rgba(37,99,235,0.28)",

  "&:hover": {
    background:
      "linear-gradient(90deg, #2563EB 0%, #5B4FFF 100%)",
  },
},
  planCardActive: {
    borderColor: "#0066FF",
    background: "linear-gradient(135deg, #EFF6FF 0%, #F0F9FF 100%)",
    boxShadow: "0 8px 24px rgba(0,102,255,0.15)",
  },
  planName: {
    fontWeight: 800,
    color: "#0A1628",
    fontSize: 15,
    marginBottom: 6,
    letterSpacing: "-0.2px",
  },
  planMeta: {
    display: "flex",
    alignItems: "center",
    gap: 5,
    fontSize: 11.5,
    color: "#64748B",
    lineHeight: 1.6,
    fontWeight: 500,
  },
  planPrice: {
    fontWeight: 800,
    fontSize: 20,
    color: "#0066FF",
    marginTop: 8,
    display: "block",
    letterSpacing: "-0.5px",
  },
  planTrialBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    background: "linear-gradient(135deg, #00A86B, #00D084)",
    color: "#fff",
    fontSize: 10,
    fontWeight: 800,
    padding: "3px 8px",
    borderRadius: 20,
    marginBottom: 8,
    letterSpacing: "0.3px",
  },
  planCheckIcon: {
    position: "absolute",
    top: 10, right: 10,
    width: 22, height: 22,
    borderRadius: "50%",
    background: "#0066FF",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: 12, color: "#fff", fontWeight: 700,
  },
  planSectionLabel: {
    fontWeight: 700, fontSize: 11,
    textTransform: "uppercase", letterSpacing: "0.6px",
    color: "#94A3B8", marginBottom: 8, display: "block",
  },
  trialBanner: {
    background: "linear-gradient(135deg, rgba(0,168,107,0.08), rgba(0,208,132,0.05))",
    border: "1px solid rgba(0,168,107,0.2)",
    borderRadius: 12, padding: "10px 14px",
    display: "flex", alignItems: "center", gap: 8,
    marginBottom: 10,
  },
  whatsappButton: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    backgroundColor: "#25D366",
    borderRadius: "50%",
    width: "60px",
    height: "60px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 4px 12px #044012",
    cursor: "pointer",
    zIndex: 999,
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "#1ebe5b",
      transform: "scale(1.1)",
    },
  },
  whatsappIcon: {
    fontSize: 34,
    color: "#fff",
  },
  versionCompany: {
    marginTop: 14,
    textAlign: "center",
    fontSize: 12,
    fontWeight: 600,
    color: "#64748b",
    letterSpacing: "0.02em",
  },
}));

const UserSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Obrigatório"),
  companyName: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Obrigatório"),
  password: Yup.string().min(5, "Too Short!").max(50, "Too Long!"),
  email: Yup.string().email("Invalid email").required("Obrigatório"),
  phone: Yup.string()
    .required("Obrigatório")
    .test(
      "valid-br-phone",
      "Informe DDD + número (8 ou 9 dígitos).",
      value => {
        const digits = String(value || "").replace(/\D/g, "");
        return digits.length === 10 || digits.length === 11;
      }
    ),
});

const formatSignupPhone = value => {
  const digits = String(value || "").replace(/\D/g, "").slice(0, 11);
  if (!digits) return "";

  const ddd = digits.slice(0, 2);
  const rest = digits.slice(2);

  if (rest.length <= 4) {
    return `(${ddd}${rest ? ") " + rest : ""}`;
  }

  if (rest.length <= 8) {
    return `(${ddd}) ${rest.slice(0, 4)}-${rest.slice(4)}`;
  }

  return `(${ddd}) ${rest.slice(0, 5)}-${rest.slice(5)}`;
};

const normalizeSignupPhone = value =>
  String(value || "").replace(/\D/g, "").slice(0, 11);


const getCookieValue = name => {
  if (typeof document === "undefined") return null;

  const match = document.cookie
    .split("; ")
    .find(row => row.startsWith(`${name}=`));

  return match
    ? decodeURIComponent(match.split("=").slice(1).join("="))
    : null;
};

const cleanAttributionValue = value => {
  if (value === undefined || value === null) return null;

  const normalized = String(value).trim();
  return normalized || null;
};

const buildSignupAttribution = () => {
  if (typeof window === "undefined") return null;

  const params = qs.parse(window.location.search);

  let stored = {};

  try {
    stored = JSON.parse(
      localStorage.getItem("korax_acquisition_attribution") || "{}"
    );
  } catch (err) {
    stored = {};
  }

  const attribution = {
    source:
      cleanAttributionValue(params.utm_source) ||
      cleanAttributionValue(stored.source),

    medium:
      cleanAttributionValue(params.utm_medium) ||
      cleanAttributionValue(stored.medium),

    campaign:
      cleanAttributionValue(params.utm_campaign) ||
      cleanAttributionValue(stored.campaign),

    content:
      cleanAttributionValue(params.utm_content) ||
      cleanAttributionValue(stored.content),

    term:
      cleanAttributionValue(params.utm_term) ||
      cleanAttributionValue(stored.term),

    campaignId:
      cleanAttributionValue(params.campaign_id) ||
      cleanAttributionValue(params.campaignId) ||
      cleanAttributionValue(stored.campaignId),

    adsetId:
      cleanAttributionValue(params.adset_id) ||
      cleanAttributionValue(params.adsetId) ||
      cleanAttributionValue(stored.adsetId),

    adId:
      cleanAttributionValue(params.ad_id) ||
      cleanAttributionValue(params.adId) ||
      cleanAttributionValue(stored.adId),

    fbclid:
      cleanAttributionValue(params.fbclid) ||
      cleanAttributionValue(stored.fbclid),

    fbp:
      cleanAttributionValue(getCookieValue("_fbp")) ||
      cleanAttributionValue(stored.fbp),

    fbc:
      cleanAttributionValue(getCookieValue("_fbc")) ||
      cleanAttributionValue(stored.fbc),

    landingPage:
      cleanAttributionValue(stored.landingPage),

    referrer:
      cleanAttributionValue(stored.referrer)
  };

  return Object.values(attribution).some(Boolean)
    ? attribution
    : null;
};

const SignUp = () => {
const [turnstileToken, setTurnstileToken] = useState("");

const [whatsappVerificationToken, setWhatsappVerificationToken] =
  useState("");
const [verifiedPhone, setVerifiedPhone] = useState("");
const [whatsappCode, setWhatsappCode] = useState("");
const [whatsappCodeSent, setWhatsappCodeSent] = useState(false);
const [whatsappSending, setWhatsappSending] = useState(false);
const [whatsappVerifying, setWhatsappVerifying] = useState(false);
const [whatsappCooldown, setWhatsappCooldown] = useState(0);

const classes = useStyles();
  const history = useHistory();
  const { getPlanList } = usePlans();
  const [plans, setPlans] = useState([]);
  const [branding, setBranding] = useState({
    loginLogo: "/logo.png",
    loginBackground: "",
    loginWhatsapp: "https://wa.me/5500000000000",
    companyName: "Whaticket",
  });
  const [userCreationEnabled, setUserCreationEnabled] = useState(true);

  let companyId = null;
  const params = qs.parse(window.location.search);
  if (params.companyId !== undefined) {
    companyId = params.companyId;
  }

  const initialState = {
    name: "",
    email: "",
    password: "",
    phone: "",
    companyId,
    companyName: "",
  };

  const [user] = useState(initialState);

  const backendUrl =
    process.env.REACT_APP_BACKEND_URL === "https://localhost:8090"
      ? "https://localhost:8090"
      : process.env.REACT_APP_BACKEND_URL;

  const resolveImageUrl = (value, fallback) => {
    if (!value) return fallback;
    if (value.startsWith("http")) return value;
    if (!backendUrl) return value;
    const normalizedBase = backendUrl.replace(/\/+$/, "");
    const path = value.startsWith("/") ? value : `/${value}`;
    return `${normalizedBase}${path}`;
  };

  const isDefaultBackendBackground = (value) => {
    if (!value) return true;
    const normalized = String(value).toLowerCase();
    return normalized.includes("/public/branding/login-background-default");
  };

  useEffect(() => {
    const fetchUserCreationStatus = async () => {
      try {
        const response = await fetch(`${backendUrl}/settings/userCreation`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch user creation status");
        }

        const data = await response.json();
        const isEnabled = data.userCreation === "enabled";
        setUserCreationEnabled(isEnabled);

        if (!isEnabled) {
          toast.info("Cadastro de novos usuários está desabilitado.");
          history.push("/login");
        }
      } catch (err) {
        console.error("Erro ao verificar userCreation:", err);
        setUserCreationEnabled(false);
        toast.error("Erro ao verificar permissão de cadastro.");
        history.push("/login");
      }
    };

    fetchUserCreationStatus();
  }, [backendUrl, history]);

  useEffect(() => {
    const fetchData = async () => {
      const planList = await getPlanList({ listPublic: "false" });
      setPlans(planList);
    };
    fetchData();
  }, [getPlanList]);

  useEffect(() => {
    const fetchBranding = async () => {
      try {
        const [{ data: brandingData }, { data: publicAppName }] =
          await Promise.all([
            openApi.get("/global-config/public-branding"),
            openApi.get("/public-settings/appName", {
              params: { token: "wtV" },
            }),
          ]);

        setBranding({
          loginLogo: brandingData.loginLogo || "/logo.png",
          loginBackground: isDefaultBackendBackground(brandingData.loginBackground)
            ? ""
            : brandingData.loginBackground,
          loginWhatsapp: brandingData.loginWhatsapp || "https://wa.me/5500000000000",
          companyName: String(publicAppName || "").trim() || "Whaticket",
        });
      } catch (err) {
        // segue com fallback local
      }
    };
    fetchBranding();
  }, []);

  useEffect(() => {
    if (whatsappCooldown <= 0) {
      return undefined;
    }

    const timer = setTimeout(() => {
      setWhatsappCooldown(current =>
        Math.max(0, current - 1)
      );
    }, 1000);

    return () => clearTimeout(timer);
  }, [whatsappCooldown]);

  const handleSendWhatsAppCode = async rawPhone => {
    const phone = normalizeSignupPhone(rawPhone);

    if (phone.length !== 10 && phone.length !== 11) {
      toast.error("Informe um WhatsApp válido com DDD.");
      return;
    }

    if (whatsappSending || whatsappCooldown > 0) {
      return;
    }

    setWhatsappSending(true);

    try {
      await openApi.post("/auth/whatsapp/send-code", {
        phone
      });

      /*
       * Um novo código invalida qualquer confirmação
       * anterior mantida apenas no estado da tela.
       */
      setWhatsappVerificationToken("");
      setVerifiedPhone("");
      setWhatsappCode("");
      setWhatsappCodeSent(true);
      setWhatsappCooldown(60);

      toast.success(
        "Código enviado para o seu WhatsApp."
      );
    } catch (err) {
      toastError(err);
    } finally {
      setWhatsappSending(false);
    }
  };

  const handleVerifyWhatsAppCode = async rawPhone => {
    const phone = normalizeSignupPhone(rawPhone);
    const code = String(whatsappCode || "")
      .replace(/\D/g, "")
      .slice(0, 6);

    if (phone.length !== 10 && phone.length !== 11) {
      toast.error("Informe um WhatsApp válido com DDD.");
      return;
    }

    if (!/^\d{6}$/.test(code)) {
      toast.error("Digite os 6 números enviados pelo WhatsApp.");
      return;
    }

    if (whatsappVerifying) {
      return;
    }

    setWhatsappVerifying(true);

    try {
      const { data } = await openApi.post(
        "/auth/whatsapp/verify-code",
        {
          phone,
          code
        }
      );

      if (!data?.verificationToken) {
        throw new Error(
          "A confirmação do WhatsApp não retornou uma autorização válida."
        );
      }

      setWhatsappVerificationToken(
        data.verificationToken
      );
      setVerifiedPhone(phone);

      toast.success(
        "WhatsApp confirmado com sucesso."
      );
    } catch (err) {
      toastError(err);
    } finally {
      setWhatsappVerifying(false);
    }
  };

  const handleSignUp = async (values) => {
    try {
      if (!turnstileToken) {
        toast.error("Confirme que você é humano antes de continuar.");
        return;
      }

      const normalizedPhone =
        normalizeSignupPhone(values.phone);

      if (
        !whatsappVerificationToken ||
        verifiedPhone !== normalizedPhone
      ) {
        toast.error(
          "Confirme seu WhatsApp pelo código enviado antes de criar a conta."
        );
        return;
      }

      // Usa o primeiro plano disponível automaticamente
      const defaultPlanId = plans.length > 0 ? plans[0].id : 1;

      const { data } = await openApi.post("/auth/signup", {
        ...values,
        turnstileToken,
        verificationToken: whatsappVerificationToken,
        planId: values.planId || defaultPlanId,
        phone: normalizedPhone,
        attribution: buildSignupAttribution()
      });

      if (!data?.token || !data?.user) {
        throw new Error("A sessão não foi devolvida pelo cadastro.");
      }

      localStorage.setItem(
        "token",
        JSON.stringify(data.token)
      );

      if (data.user?.company?.dueDate) {
        localStorage.setItem(
          "companyDueDate",
          data.user.company.dueDate
        );
      }

      toast.success(
        "Conta criada com sucesso. Vamos configurar sua operação."
      );

      window.location.replace("/onboarding");
    } catch (err) {
      toastError(err);
    }
  };

  if (!userCreationEnabled) {
    return null;
  }

  return (
    <div className={`${classes.root} ${branding.loginBackground ? classes.rootWithBackground : ""}`}>
      {!!branding.loginBackground && (
        <>
          <div className={classes.backgroundMedia}>
            <img
              src={resolveImageUrl(branding.loginBackground, "")}
              alt="Background cadastro"
              className={classes.backgroundImg}
            />
          </div>
          <div className={classes.backgroundOverlay} />
        </>
      )}
      <div className={classes.paper}>
        <img
          src={resolveImageUrl(branding.loginLogo, defaultLoginLogo)}
          alt="Logo"
          className={classes.logoImg}
        />
        <Typography component="h1" variant="h5" className={classes.signupTitle}>
  Criar conta
</Typography>
        <Typography className={classes.subtitle}>
          Teste a Korax IA na prática e veja como ela pode vender por você no WhatsApp
        </Typography>

        <Formik
          initialValues={user}
          enableReinitialize={true}
          validationSchema={UserSchema}
          onSubmit={async (values, actions) => {
            await handleSignUp(values);
            actions.setSubmitting(false);
          }}
        >
          {({ touched, errors, values, setFieldValue }) => (
            <Form className={classes.form}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Field
                    as={TextField}
                    variant="outlined"
                    fullWidth
                    id="companyName"
                    placeholder={i18n.t("signup.form.company")}
                    error={touched.companyName && Boolean(errors.companyName)}
                    helperText={touched.companyName && errors.companyName}
                    name="companyName"
                    autoComplete="companyName"
                    autoFocus

InputLabelProps={{
  shrink: false,
  style: { display: "none" }
}}
InputProps={{
  style: {
    background: "#ffffff",
    borderRadius: 12,
    color: "#0f172a",
    height: 56,
    overflow: "hidden",
  },
}}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    as={TextField}
                    autoComplete="name"
                    name="name"
                    error={touched.name && Boolean(errors.name)}
                    helperText={touched.name && errors.name}
                    variant="outlined"
                    fullWidth
                    id="name"
                    placeholder="Nome"
InputLabelProps={{
  shrink: false,
  style: { display: "none" }
}}
InputProps={{
  style: {
    background: "#ffffff",
    borderRadius: 12,
    color: "#0f172a",
    height: 56,
    overflow: "hidden",
  },
}}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    as={TextField}
                    variant="outlined"
                    fullWidth
                    id="email"
                    placeholder="Email"
                    name="email"
                    error={touched.email && Boolean(errors.email)}
                    helperText={touched.email && errors.email}
                    autoComplete="email"
                    inputProps={{ style: { textTransform: "lowercase" } }}
InputLabelProps={{
  shrink: false,
  style: { display: "none" }
}}
InputProps={{
  style: {
    background: "#ffffff",
    borderRadius: 12,
    color: "#0f172a",
    height: 56,
    overflow: "hidden",
  },
}}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    as={TextField}
                    variant="outlined"
                    fullWidth
                    name="password"
                    error={touched.password && Boolean(errors.password)}
                    helperText={touched.password && errors.password}
                    placeholder="Senha"
                    type="password"
                    id="password"
                    autoComplete="current-password"

             InputLabelProps={{
  shrink: false,
  style: { display: "none" }
}}
InputProps={{
  style: {
    background: "#ffffff",
    borderRadius: 12,
    color: "#0f172a",
    height: 56,
    overflow: "hidden",
  },
}}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    id="phone"
                    name="phone"
                    autoComplete="tel-national"
                    placeholder="(00) 00000-0000"
                    value={formatSignupPhone(values.phone)}
                    onChange={(e) => {
                      const nextPhone =
                        formatSignupPhone(e.target.value);

                      setFieldValue("phone", nextPhone);

                      const normalized =
                        normalizeSignupPhone(nextPhone);

                      if (
                        whatsappVerificationToken &&
                        verifiedPhone !== normalized
                      ) {
                        setWhatsappVerificationToken("");
                        setVerifiedPhone("");
                        setWhatsappCode("");
                        setWhatsappCodeSent(false);
                      }
                    }}
                    error={touched.phone && Boolean(errors.phone)}
                    helperText={touched.phone && errors.phone}
InputLabelProps={{
  shrink: false,
  style: { display: "none" }
}}
InputProps={{
  style: {
    background: "#ffffff",
    borderRadius: 12,
    color: "#0f172a",
    height: 56,
    overflow: "hidden",
  },
}}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Button
                    type="button"
                    fullWidth
                    variant="outlined"
                    disabled={
                      whatsappSending ||
                      whatsappCooldown > 0 ||
                      (
                        !!whatsappVerificationToken &&
                        verifiedPhone ===
                          normalizeSignupPhone(values.phone)
                      )
                    }
                    onClick={() =>
                      handleSendWhatsAppCode(values.phone)
                    }
                    style={{
                      height: 44,
                      borderRadius: 12,
                      textTransform: "none",
                      fontWeight: 700,
                      color:
                        whatsappVerificationToken &&
                        verifiedPhone ===
                          normalizeSignupPhone(values.phone)
                          ? "#16a34a"
                          : "#2563eb",
                      borderColor:
                        whatsappVerificationToken &&
                        verifiedPhone ===
                          normalizeSignupPhone(values.phone)
                          ? "#16a34a"
                          : "rgba(59,130,246,0.55)",
                      background:
                        whatsappVerificationToken &&
                        verifiedPhone ===
                          normalizeSignupPhone(values.phone)
                          ? "rgba(22,163,74,0.08)"
                          : "rgba(37,99,235,0.08)"
                    }}
                  >
                    {whatsappVerificationToken &&
                    verifiedPhone ===
                      normalizeSignupPhone(values.phone)
                      ? "WhatsApp verificado"
                      : whatsappSending
                        ? "Enviando código..."
                        : whatsappCooldown > 0
                          ? `Reenviar em ${whatsappCooldown}s`
                          : whatsappCodeSent
                            ? "Enviar novo código"
                            : "Enviar código pelo WhatsApp"}
                  </Button>
                </Grid>

                {whatsappCodeSent &&
                  !(
                    whatsappVerificationToken &&
                    verifiedPhone ===
                      normalizeSignupPhone(values.phone)
                  ) && (
                    <>
                      <Grid item xs={8}>
                        <TextField
                          variant="outlined"
                          fullWidth
                          id="whatsappCode"
                          placeholder="Código de 6 dígitos"
                          value={whatsappCode}
                          onChange={e =>
                            setWhatsappCode(
                              String(e.target.value || "")
                                .replace(/\D/g, "")
                                .slice(0, 6)
                            )
                          }
                          inputProps={{
                            inputMode: "numeric",
                            maxLength: 6,
                            style: {
                              textAlign: "center",
                              letterSpacing: "0.22em",
                              fontWeight: 800
                            }
                          }}
                          InputLabelProps={{
                            shrink: false,
                            style: { display: "none" }
                          }}
                          InputProps={{
                            style: {
                              background: "#ffffff",
                              borderRadius: 12,
                              color: "#0f172a",
                              height: 48
                            }
                          }}
                        />
                      </Grid>

                      <Grid item xs={4}>
                        <Button
                          type="button"
                          fullWidth
                          variant="contained"
                          color="primary"
                          disabled={
                            whatsappVerifying ||
                            whatsappCode.length !== 6
                          }
                          onClick={() =>
                            handleVerifyWhatsAppCode(values.phone)
                          }
                          style={{
                            height: 48,
                            borderRadius: 12,
                            textTransform: "none",
                            fontWeight: 700
                          }}
                        >
                          {whatsappVerifying
                            ? "Validando..."
                            : "Confirmar"}
                        </Button>
                      </Grid>
                    </>
                  )}

              </Grid>
<Turnstile
  action="signup"
  onToken={setTurnstileToken}
  theme="light"
/>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                
           ACESSE GRÁTIS
              </Button>

              <Grid container justifyContent="center">
                <Grid item>
                  <Link
                    href="#"
                    variant="body2"
                    component={RouterLink}
                    to="/login"
                  >
                    {i18n.t("signup.buttons.login")}
                  </Link>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
        <Typography className={classes.versionCompany}>
          {`v15.0.2 ${branding.companyName}`}
        </Typography>
      </div>
      <div
        className={classes.whatsappButton}
        onClick={() => window.open(branding.loginWhatsapp)}
      >
        <WhatsAppIcon className={classes.whatsappIcon} />
      </div>
    </div>
  );
};

export default SignUp;
